import React from 'react';
import './BonusPromotion.css';

const BonusPromotion = () => {
  return (
 <div className="landing-container">
      {/* Header Section */}
      <div className="header-section">
        <h1 className="header-title">Trade Smarter,<br />Start With More</h1>

      </div>

      {/* Bonus Promo Section */}
      <div className="promo-section">
        <img
          src={require("../../../assets/offer 1 asset .png")}
          alt="Trader"
          className="promo-image"
        />
        <div className="promo-text">
          <h2>Get Up to $1,000 Bonus When You Fund Your Account Today</h2>
          <p>
            Whether you're starting fresh or scaling up, GivTrade gives you 20% more capital
            to make your next move count — up to $1,000 bonus, instantly added to your deposit.
          </p>
          <button className="claim-button" 
           onClick={() => window.location.href = 'https://accounts.giv.trade/marketing/links/go/2'}>CLAIM YOUR BONUS NOW</button>
        </div>
      </div>

      {/* Mid Section */}
      <div className="mid-section">
        <div className="strategy-text">
          <h3>You’ve got the strategy, but not the capital to maximize it.</h3>
          <p>Don’t let limited funds limit your potential.</p>
        </div>
        <div className="smart-traders-box">
          <h3>GivTrade <br /> rewards smart traders</h3>
          <p>by adding 20% on top of your deposit (up to $5,000).</p>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits-section">
        <h2>
          That’s up to $1,000 extra to use right away!<br />
          No waiting, no nonsense.
        </h2>
        <div className="benefits-grid">
          <div className="benefits-column">
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>%20 Bonus on Deposits</strong><br />Fund your account and get rewarded instantly.</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Up to $1,000 Bonus</strong><br />More capital to take larger, smarter positions.</p>
            </div>
          </div>
          <div className="benefits-column2">
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Boosted Trading Potential</strong><br />Amplify your positions with more firepower.</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Ideal for Every Trader</strong><br />Great for stepping in or scaling up.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Final Call-to-Action Section */}
      <div className="final-cta-section">
        <h2>
          Secure offer in seconds.<br />
          <strong>No commitment required.</strong>
        </h2>
        <button className="cta-button" 
         onClick={() => window.location.href = 'https://accounts.giv.trade/marketing/links/go/2'}>GET MY BONUS NOW</button>
      </div>
    </div>
  );
};

export default BonusPromotion;